// @flow
import * as React from 'react';
import { CardActionArea, Chip, IconButton, Stack, SxProps, Typography } from '@mui/material';
import moment from "moment";
import {useState} from "react";
import {
  AgentView,
  CallHistoryItemsQuery,Portal
} from '../../../../../shared';
import { getUserName } from '@coverright/utils';
import { Client } from '../../../../../shared/api/use-client-subscription';
import { ArrowCircleDownIcon, ArrowCircleUpIcon, MagicWandIcon, PenIcon } from '@phosphor-icons/react';
import {
  CallHistoryCallType,
  CallHistoryResultInput
} from '@coverright/data-access/types/enrollment';
import { useCallForm, withCallForm } from './call-form-modal';

type Call = CallHistoryItemsQuery['callHistoryItems']['data'][0]

type Props = {
  call: Call,
  client: Partial<Client>;
  onClick: () => void;
  onChange?: () => void;
  sx?: SxProps;
};
export const CallCard = withCallForm(({call, client, onClick, onChange, sx = {}}: Props) => {
  const [disableRipple, setDisableRipple] = useState(false)
  const agentName = call.agent ? getUserName(call.agent) : ''
  const clientName = client ? getUserName(client) : ''
  const {open} = useCallForm()

  return (
    <Portal sx={sx}>
      <CardActionArea sx={{py: 1, px: 2}}
                      component={'div'}
                      disableRipple={disableRipple}
                      onClick={onClick}>
        <Stack gap={2} direction={'row'} alignItems={'center'}>
          <Stack>
            <Typography color={'textSecondary'} variant={'body2'} fontWeight={500}>
              {moment(call.createdAt).format('L')}
            </Typography>
            <Typography color={'#6d6d6d'} variant={'caption'} align={'right'}>
              {moment(call.createdAt).format('LT')}
            </Typography>
          </Stack>

          <Stack gap={1} direction={'row'} alignItems={'flex-start'}>
            <AgentView agent={{
              picUrl: call.agent?.picUrl,
              email: call.agent?.email ? call.agent.email : undefined,
              fullName: `${agentName} with ${clientName}`
            }} />

            {call.hasAIAnalysis && <MagicWandIcon size={16} style={{ marginTop: 3 }} weight={'fill'} />}
          </Stack>


          <Stack flex={1} gap={.5}>
            <Stack direction={'row'} gap={1} alignItems={'center'} justifyContent={'flex-end'}>

              <Stack direction={'row'} spacing={.5} alignItems={'center'}>
                {call.callType === CallHistoryCallType.Inbound && <ArrowCircleDownIcon style={{minWidth: 18}} size={18} color={'#03986B'} weight={'bold'}/>}
                {call.callType === CallHistoryCallType.Outbound && <ArrowCircleUpIcon style={{minWidth: 18}} size={18} color={'#4599B2'} weight={'bold'}/>}
                <Typography  variant={'caption'} sx={{whiteSpace: 'nowrap'}}>
                  {stringifyCallType(call.callType)}
                </Typography>
              </Stack>

              {onChange && <IconButton size={'small'}
                                       onMouseEnter={() => setDisableRipple(true)}
                                       onMouseLeave={() => setDisableRipple(false)}
                                       onClick={e => {
                                         e.stopPropagation();
                                         open(client, call, onChange);
                                       }}>
                <PenIcon color="#a6a6a6" />
              </IconButton>}
            </Stack>
            {call.result && <Chip variant={'outlined'}
                   sx={{ alignSelf: 'flex-end' }}
                   color={getCallResultColor(call.result)}
                   size={'small'}
                   label={stringifyCallResult(call.result)} />}
          </Stack>

        </Stack>
      </CardActionArea>
    </Portal>
  );
})

export const stringifyCallResult = (type?: CallHistoryResultInput | string | null) => {
  switch (type) {
    case CallHistoryResultInput.SuccessfulSeeNotesForCallDetails: return 'Successful - See notes for call details';
    case CallHistoryResultInput.UnsuccessfulInvalidNumber: return 'Unsuccessful - Invalid Number (Wrong/Disconnected)';
    case CallHistoryResultInput.UnsuccessfulLeftText: return 'Unsuccessful - Left Text';
    case CallHistoryResultInput.UnsuccessfulLeftVm: return 'Unsuccessful - Left VM';
    case CallHistoryResultInput.SuccessfulBookedCall: return 'Successful - Booked Call';
    case CallHistoryResultInput.UnsuccessfulLeftEmail: return 'Unsuccessful - Left Email';
    case CallHistoryResultInput.SuccessfulWarmTransfer: return 'Successful - Warm Transfer';
    default: return type || '';
  }
}
const getCallResultColor = (type?: CallHistoryResultInput | string | null) => {
  switch (type) {
    case CallHistoryResultInput.SuccessfulSeeNotesForCallDetails: return 'success';
    case CallHistoryResultInput.UnsuccessfulInvalidNumber: return 'error';
    case CallHistoryResultInput.UnsuccessfulLeftText: return 'default';
    case CallHistoryResultInput.UnsuccessfulLeftVm: return 'default';
    case CallHistoryResultInput.SuccessfulBookedCall: return 'success';
    case CallHistoryResultInput.UnsuccessfulLeftEmail: return 'default';
    case CallHistoryResultInput.SuccessfulWarmTransfer: return 'success';
    default: return 'default';
  }
}

export const stringifyCallType = (type?: CallHistoryCallType | null) => {
  switch (type) {
    case CallHistoryCallType.Inbound: return 'Inbound call';
    case CallHistoryCallType.Outbound: return 'Outbound attempt';
    default: return '';
  }
}
